import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

type ProtectedRouteProps = {
    permissionKeyList: Array<string>;
    outlet: JSX.Element;
};

export const PermissionProtectedRoute = ({ permissionKeyList, outlet }: ProtectedRouteProps) => {
  const { permission } = useSelector((state: any) => state.auth);
  const grantedPermissions: string[] = permission?.permissions?.[0] ?? [];

  if (isEmpty(grantedPermissions)) {return null;}

  if (isEmpty(permissionKeyList) || permissionKeyList.every(i => grantedPermissions.includes(i))) {return outlet;}

  return <Navigate to="/403" replace />;
};

export const AnyPermissionProtectedRoute = ({ permissionKeyList, outlet }: ProtectedRouteProps) => {
  const { permission } = useSelector((state: any) => state.auth);
  const grantedPermissions: string[] = permission?.permissions?.[0] ?? [];

  if (isEmpty(grantedPermissions)) {return null;}

  if (isEmpty(permissionKeyList) || permissionKeyList.some(i => grantedPermissions.includes(i))) {
    return outlet;
  }

  return <Navigate to="/403" replace />;
};
